import { SHOW_MODAL, HIDE_MODAL } from '../actions/modal';
import {isSuspendedShowed, isPoliciesShowed, isPoliciesModal, isSuspendedModal} from './interceptor'

const initialState = {
    modalType: null,
    modalProps: {}
};

function reducer(state = initialState, action) {

    //Prioridad 1 TERMINOS y CONDICIONES
    if (isPoliciesShowed(action, state)) {
        if(!isPoliciesModal(action, state)) return state;
    }
    //Prioridad 2 USUARIO SUSPENDIDO
    if (isSuspendedShowed(action, state)){
        if(!isPoliciesModal(action, state)) return state;
    }

    //Priorit¡dad 3 las demas modales

    switch (action.type) {
        case SHOW_MODAL:
            return {
                modalType: action.modalType,
                modalProps: action.modalProps
            };
        case HIDE_MODAL:
            return initialState;

        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/reducers/modal.js